import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { Award, Home, LogOut, User, UserPlus, Wallet } from 'lucide-react';

const nav = [
  { to: '/partner', label: 'Home', icon: Home, end: true },
  { to: '/partner/referrals', label: 'Referrals', icon: UserPlus },
  { to: '/partner/points', label: 'Points', icon: Award },
  { to: '/partner/payouts', label: 'Payouts', icon: Wallet },
  { to: '/partner/profile', label: 'Profile', icon: User },
];

export default function PartnerPortalLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('partner_user') || '{}');

  const signOut = () => {
    localStorage.removeItem('partner_token');
    localStorage.removeItem('partner_user');
    navigate('/partner/login');
  };

  const active = (to: string, end?: boolean) => {
    if (end) return location.pathname === to;
    return location.pathname.startsWith(to);
  };

  return (
    <div className="min-h-screen bg-[#0a0f1a] text-slate-100">
      <div
        className="pointer-events-none fixed inset-0 opacity-40"
        style={{
          background:
            'radial-gradient(ellipse 80% 50% at 50% -20%, rgba(56,189,248,0.35), transparent), radial-gradient(ellipse 60% 40% at 100% 50%, rgba(167,139,250,0.2), transparent)',
        }}
      />
      <header className="sticky top-0 z-30 border-b border-white/10 bg-[#0a0f1a]/80 backdrop-blur-xl">
        <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-4 py-3 sm:py-4">
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-cyan-400/90">
              True Partner Network
            </p>
            <h1 className="text-lg font-semibold bg-gradient-to-r from-white to-slate-400 bg-clip-text text-transparent">
              Referral Portal
            </h1>
          </div>
          <p className="hidden text-sm text-slate-400 sm:block">
            {user?.firstName} {user?.lastName}
          </p>
        </div>
        <nav className="mx-auto flex max-w-5xl gap-1 overflow-x-auto px-4 pb-3 [-webkit-overflow-scrolling:touch]">
          {nav.map(({ to, label, icon: Icon, end }) => (
            <Link
              key={to}
              to={to}
              className={`flex shrink-0 items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition ${
                active(to, end)
                  ? 'bg-gradient-to-r from-cyan-500 to-violet-500 text-white shadow-lg shadow-cyan-500/25'
                  : 'text-slate-400 hover:bg-white/5 hover:text-white'
              }`}
            >
              <Icon className="h-4 w-4" />
              {label}
            </Link>
          ))}
          <button
            type="button"
            onClick={signOut}
            className="ml-auto flex shrink-0 items-center gap-2 rounded-full px-3 py-2 text-sm text-slate-400 hover:bg-white/5 hover:text-white sm:px-4"
          >
            <LogOut className="h-4 w-4" />
            <span className="hidden sm:inline">Sign out</span>
          </button>
        </nav>
      </header>
      <main className="relative mx-auto max-w-5xl px-4 py-6 sm:py-8">
        <Outlet />
      </main>
    </div>
  );
}
